import { getGlobalHeadersAsObject } from "../global-headers";

export type TagHistory = {
	id: number;
	name: string;
	timestamp: string;
	action: string;
	username: string;
};

export const getTagHistory = (
	objectName: string,
	objectId: number
): Promise<TagHistory[]> => {
	if (!objectId || typeof objectId !== "number") {
		throw new Error(
			`getPersonExperienceById called with invalid argument id '${objectId}'. Expected number`
		);
	}
	return fetch(`/api/v2/${objectName}/${objectId}/taghistory/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const putTagHistory = (
	tagHistoryId: number,
	date: string
): Promise<TagHistory[]> => {
	if (!tagHistoryId || typeof tagHistoryId !== "number") {
		throw new Error(
			`getPersonExperienceById called with invalid argument id '${tagHistoryId}'. Expected number`
		);
	}
	return fetch(`/api/v2/taghistory/${tagHistoryId}/`, {
		method: "PUT",
		body: JSON.stringify({
			timestamp: date,
		}),
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
	}).then((res) => res.json());
};

export const postTagHistory = (
	objectName: string,
	objectId: number,
	tagName: string,
	date: string
): Promise<TagHistory[]> => {
	return fetch(`/api/v2/${objectName}/${objectId}/taghistory/`, {
		method: "POST",
		body: JSON.stringify({
			timestamp: date,
			name: tagName,
		}),
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
	}).then((res) => res.json());
};

export const deleteTagHistory = async (tagHistoryId: number): Promise<void> => {
	const res = await fetch(`/api/v2/taghistory/${tagHistoryId}/`, {
		method: "DELETE",
		headers: getGlobalHeadersAsObject(),
	});
	if (!res.ok) {
		throw new Error(`Failed to delete tag history: ${res.status}`);
	}
};
